import { ModuleInterface } from './types';
import SelectField from './Fields/SelectField';
import StaticSelectField from './Fields/StaticSelectField';
import DateField from './Fields/DateField';
import InputField from './Fields/InputField';
import RadioField from './Fields/RadioField';
import CheckboxField from './Fields/CheckboxField';
import StaticCheckboxField from './Fields/StaticCheckboxField';
import SwitchField from './Fields/SwitchField';

const renderFilterField = (field: ModuleInterface) => {
    const customLayout = { labelCol: { span: 6 }, wrapperCol: { span: 12 } };

    switch (field.type) {
        // case 'input':
        // return <InputField {...field} />;
        case 'asyncSelect':
            return <SelectField {...field} layout={customLayout} />;
        case 'select':
            return <StaticSelectField {...field} layout={customLayout} />;
        case 'dateRange':
            return <DateField {...field} layout={customLayout} />;
        case 'asyncRadio':
            return <RadioField {...field} layout={customLayout} />;
        case 'asyncCheckbox':
            return <CheckboxField {...field} layout={customLayout} />;
        case 'checkbox':
            return <StaticCheckboxField {...field} layout={customLayout} />;
        case 'switch':
            return <SwitchField {...field} layout={customLayout} />;

        default:
            return null;
    }
};

export { renderFilterField };
